/* @flow strict */

import * as React from 'react';
// import { GET } from '/client/src/api';
import Loader from '/client/src/components/Loader';

export const CheckStripeConnection = ({ children, handleShowStripeWarning }: React.Node): React.Element => {
  // const checkRequest = async (): React.Element => {
  //   try {
  //     const { result } = await GET('/api/v1/1/merchants/paymentmethod/stripe_token_direct/settings');
  //     const isConnect = _.some(result, r => r.connect_account);
  //     const Component = children;
  //
  //
  //     return <Component isConnect={isConnect} />;
  //   } catch (e) {
  //     console.log(e);
  //     console.error('Can\'t check strip');
  //   }
  // };
  //
  // checkRequest();

  // const [isConnect, setIsConnect] = React.useState(false);
  // const Component = children;
  const handleLoaded = (error: Error, { data }: any) => {
    if (error) {
      console.log(error);
    }
    const _isConnect = _.some(data.result, r => r.connect_account);

    console.log(_isConnect, data.result);

    handleShowStripeWarning(_isConnect);
  };

  return (
    <Loader
      url={'/api/v1/1/merchants/paymentmethod/stripe_token_direct/settings'}
      onLoaded={handleLoaded}
    >
      {children}
    </Loader>
  );
};
